export default __webpack_public_path__ + "static/media/google-logo.c3d26fca.svg";